document.addEventListener("DOMContentLoaded", () => {
  const readMoreButton = document.querySelector(".read-more-button");
  const description = document.querySelector(".collection-description");

  if (description.offsetHeight >= description.scrollHeight) {
    readMoreButton.classList.add("hide");
  }

  readMoreButton.addEventListener("click", () => {
    if (description.classList.contains("expanded")) {
      description.classList.remove("expanded");
      readMoreButton.textContent = "Read more";
    } else {
      description.classList.add("expanded");
      readMoreButton.textContent = "Read less";
    }
  });
});